import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  Flex,
  Heading,
  Image,
  Input,
  Link,
  Stack,
  Text,
} from "@chakra-ui/react";
import { PRIMARY_COLOR } from "../../constants/colors";
import api from "../../services/api";
import { toast } from "react-toastify";
import { AuthContext } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  const { setUser } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await api.post("/admin/login", { email, password });
      setUser({ token: response.data.token, info: response.data.admin });
      localStorage.setItem("@aqvex/user", JSON.stringify(response.data.admin));
      localStorage.setItem("@aqvex/token", JSON.stringify(response.data.token));
      navigate("/painel");
    } catch (err) {
      toast.error(
        err.response.data.error ??
          "Erro ao realizar login, tente novamente mais tarde!",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bg="gray.50"
      p={4}
      flexDirection="column"
      gap="40px"
    >
      <Image src="/logo-aqvex.png" cursor="pointer" width="200px" />
      <Box
        as="form"
        onSubmit={handleSubmit}
        bg="white"
        rounded="lg"
        boxShadow="lg"
        p={{ base: 6, md: 10 }}
        width={{ base: "100%", sm: "420px" }}
      >
        <Flex flexDirection="column" width="100%" gap="10px">
          {" "}
          <Flex flexDirection="column" gap="10px">
            <Text fontWeight="600">Email *</Text>
            <Input
              type="email"
              placeholder="Digite seu email..."
              padding="15px"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Flex>
          <Flex flexDirection="column" gap="10px">
            <Text fontWeight="600">Senha *</Text>
            <Input
              type="password"
              placeholder="Digite sua senha..."
              padding="15px"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Flex>
          <Button
            type="submit"
            colorScheme="blue"
            isFullWidth
            loading={isSubmitting}
            width="100%"
            backgroundColor={PRIMARY_COLOR}
          >
            Entrar
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
}
